'use strict';

import Swiper from 'swiper';
import 'swiper/css';

const initBrowserCheck = require('./function_modules/browserCheck');
const initSelect = require('./function_modules/select');
const initModals = require('./function_modules/modal');
const isMobile = checkIsMobile();

document.addEventListener('DOMContentLoaded', () => {
    initBrowserCheck();
    initSlide();
    initModals();
    initDownload();
    initUpBtn();
    initFilterBtn();
    initSelect();
    initFilter();
    initFilterSelects();
    initTagsSwiper();
    initUploadFormConsent();
    initCoopButton();
});

function checkIsMobile() {
    const isMobileSize = window.innerWidth < 768 || screen.width < 768;
    const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    return isMobileSize && hasTouchSupport;
}

function initUploadFormConsent() {
    const uploadConsentCheckbox = jQuery('#upload-consent-check');
    if (uploadConsentCheckbox.is(':checked')) {
        jQuery('#upload-consent-file').removeClass('is-disabled');
    } else {
        jQuery('#upload-consent-file').addClass('is-disabled');
    }

    uploadConsentCheckbox.on('change', function () {
        if (uploadConsentCheckbox.is(':checked')) {
            jQuery('#upload-consent-file').removeClass('is-disabled');
        } else {
            jQuery('#upload-consent-file').addClass('is-disabled');
        }
    });
}

function initCoopButton () {
    const coopButton = jQuery('.coop-button');
    const coopButtonToggle = jQuery('.coop-button-toggle');
    coopButtonToggle.on('click', function () {
        coopButton.toggleClass('is-active');
    });
}

function initFilter() {
    const filterToggle = jQuery('.js-filter-toggle');
    const filterToggleButton = jQuery('.js-filter-toggle-button');
    const filter = jQuery('.js-media-filter');
    filterToggle.click(function () {
        filter.toggleClass('is-open');
        if (filter.hasClass('is-open')) {
            jQuery('body').addClass('scrolllock');
        } else {
            jQuery('body').removeClass('scrolllock');
        }
    });

    filterToggleButton.click(function () {
        filter.toggleClass('is-open');
        if (filter.hasClass('is-open')) {
            jQuery('body').addClass('scrolllock');
        } else {
            jQuery('body').removeClass('scrolllock');
        }
        $("html, body").animate({
            scrollTop: $("#main-content").scrollTop
        }, 0);
    });
}

function initUpBtn() {
    const mainContainer = document.querySelector('.home');
    if (!mainContainer) {
        return;
    }

    let top = document.querySelector("#scroll-up");
    let mainContentTop = $("#main-content").offset().top;

    window.addEventListener("scroll", function () {
        if (document.body.scrollTop > mainContentTop || document.documentElement.scrollTop > mainContentTop) {
            top.style.display = "flex";
        } else {
            top.style.display = "none";
        }
    });

    top.addEventListener("click", function () {
        $('html, body').animate({
            scrollTop: mainContentTop
        }, 250, "linear");
    });
}

function initFilterBtn() {
    const mainContainer = document.querySelector('.home');
    if (!mainContainer) {
        return;
    }

    let filterToggle = document.querySelector("#filter-toggle");
    let mainContentTop = $("#main-content").offset().top;
    if (document.body.scrollTop > mainContentTop || document.documentElement.scrollTop > mainContentTop) {
        if(isMobile) filterToggle.style.display = "flex";
    } else {
            if(isMobile) filterToggle.style.display = "none";
    }

    window.addEventListener("scroll", function () {
        if (document.body.scrollTop > mainContentTop || document.documentElement.scrollTop > mainContentTop) {
            if(isMobile) filterToggle.style.display = "flex";
        } else {
            if(isMobile) filterToggle.style.display = "none";
        }
    });
}

/*
* for logged-in users only. Allows them to switch between tabs
* to filter between all media, images or graphics
*/
function initSlide() {
    if (!document.querySelector('.home.logged-in')) {
        return;
    }

    const switchRow = document.querySelector(".switch-row");
    const swiperSwitchRow = new Swiper(switchRow, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        640: {
            spaceBetween: 40
        }
    });

    const all = document.querySelector(".all-slide-btn");
    const image = document.querySelector(".img-slide-btn");
    const graphic = document.querySelector(".graphic-slide-btn");
    const slides = document.querySelectorAll(".slide-content");

    // Function to set active state
    function setActive(btn1, btn2, btn3, slideToShow, slideToHide, slideToHide2) {
        btn1.classList.add('active');
        btn2.classList.remove('active');
        btn3.classList.remove('active');
        slideToShow.style.display = 'grid';
        slideToHide.style.display = 'none';
        slideToHide2.style.display = 'none';
        const event = new Event("gridLoaded");
        document.dispatchEvent(event);
    }

    // add event listener to switch buttons
    all.addEventListener("click", function () {
        if (!this.classList.contains("active")) {
            setActive(all, graphic, image, slides[0], slides[1], slides[2]);
        }
    });
    image.addEventListener("click", function () {
        if (!this.classList.contains("active")) {
            setActive(image, all, graphic, slides[1], slides[0], slides[2]);
        }
    });
    graphic.addEventListener("click", function () {
        if (!this.classList.contains("active")) {
            setActive(graphic, image, all, slides[2], slides[0], slides[1]);
        }
    });
}

function initTagsSwiper() {
    const tagsSwiper = new Swiper('.swiper.tags', {
        slidesPerView: 'auto',
        spaceBetween: 16,
    });

    document.addEventListener('tagsLoaded', () => {
        const tagsSwiper = new Swiper('.swiper.tags', {
            slidesPerView: 'auto',
            spaceBetween: 16,
        });
    });
}

function toggleDownloadModal () {
    if (!isMobile) {
        return;
    }
    const downloadModal = jQuery('.action-btn-group');
    if (downloadModal.hasClass('is-open')) {
        downloadModal.removeClass('is-open');
        jQuery('body').removeClass('scrolllock');
    } else {
        downloadModal.addClass('is-open');
        jQuery('body').addClass('scrolllock');
    }
}

function initDownload() {
    jQuery('.mobile-download-button, .action-btn-group-close').click(toggleDownloadModal);

    if (isMobile) {
        jQuery(document).click(function (event) {
            const downloadModal = jQuery('.action-btn-group');
            const target = jQuery(event.target);
            if (downloadModal.hasClass('is-open')
                && !target.closest('.action-btn-group').length
                && !target.hasClass('mobile-download-button')) {
                toggleDownloadModal();
            }
        });
    }

    const currentFormat = jQuery('.format-selection:checked');

    if(jQuery('body').hasClass('page-template-page-image')) {
        jQuery.ajax({
            type: 'POST',
            url: ajax.url,
            data: {
                action: 'get_image_download_link',
                attachment_id: currentFormat.data('image-id'),
                image_size: currentFormat.data('image-size'),
                image_type: jQuery('input[type=radio][name=format]').filter(":checked").val(),
            },
            success: function (data) {
                const returnData = JSON.parse(data);
                const downloadButton = jQuery('.media-download-button');
                if (downloadButton.attr('aria-disabled') === 'true') {
                    downloadButton.attr('data-link', returnData['image_link']);
                } else {
                    downloadButton.attr('href', returnData['image_link']);
                }
                const urlParams = new URLSearchParams(window.location.search);

                downloadButton.attr('download', returnData['image_title']);

                jQuery('#media-download-button-'+ urlParams.get('image_id')).attr('data-image-id', returnData['attachment_id']);
                jQuery('#media-download-button-'+ urlParams.get('image_id')).attr('data-image-type', returnData['image_type']);
            },
            error: function (errorThrown) {
            }
        });
    }

    jQuery(document).on("click", "input.format-selection", function () {
        jQuery.ajax({
            type: 'POST',
            url: ajax.url,
            data: {
                action: 'get_image_download_link',
                attachment_id: jQuery(this).data('image-id'),
                image_size: jQuery(this).data('image-size'),
                image_type: jQuery('input[type=radio][name=format]').filter(":checked").val(),
            },
            success: function (data) {
                const returnData = JSON.parse(data);
                const downloadButton = jQuery('.media-download-button');
                if (downloadButton.attr('aria-disabled') === 'true') {
                    downloadButton.attr('data-link', returnData['image_link']);
                } else {
                    downloadButton.attr('href', returnData['image_link']);
                }
                const urlParams = new URLSearchParams(window.location.search);

                downloadButton.attr('download', returnData['image_title']);

                jQuery('#media-download-button-'+ urlParams.get('image_id')).attr('data-image-id', returnData['attachment_id']);
                jQuery('#media-download-button-'+ urlParams.get('image_id')).attr('data-image-type', returnData['image_type']);
            },
            error: function (errorThrown) {
            }
        });
    });

    function checkDownloadButtonState(checked) {
        const downloadButton = jQuery('.media-download-button');
        if (checked) {
            downloadButton.removeAttr('disabled');
            downloadButton.removeClass('is-disabled');
            downloadButton.removeAttr('aria-disabled');
            if (downloadButton.data('link')) {
                downloadButton.attr('href', downloadButton.data('link'));
                downloadButton.removeAttr('data-link');
            }
        } else {
            downloadButton.attr('disabled', 'disabled');
            downloadButton.addClass('is-disabled');
            downloadButton.attr('aria-disabled', 'true');
            if (downloadButton.attr('href')) {
                downloadButton.attr('data-link', downloadButton.attr('href'));
                downloadButton.removeAttr('href');
            }

            jQuery('a.media-download-button').data('image-size', '');
        }
    }
    checkDownloadButtonState(jQuery('input.consent-check').prop('checked'));

    jQuery(document).on("change", "input.consent-check", function () {
        checkDownloadButtonState(jQuery(this).prop('checked'));
    });

    jQuery(document).on("click", "button.copy-terms", function (event) {
        navigator.clipboard.writeText(jQuery('#copy-terms-text').html());
    });
}

// shows the category dropdowns on frontpage
function initFilterSelects() {
    const mainContainer = document.querySelector('.home , .search');
    if (mainContainer) {
        console.log('test');
        var checkList = $('.dropdown-check-list');
        checkList.on('click', 'button.anchor', function (event) {
            var element = $(this).parent();
            if (element.hasClass('visible')) {
                element.removeClass('visible');
            } else {
                closeAllSelect(element);
                element.addClass('visible');
            }
            if (isMobile) {
                event.target.scrollIntoView();
            }
        });

        //  A function that will close all select boxes in the document, except the current select box
        function closeAllSelect(elmnt) {
            var y, i, yl, arrNo = [];
            y = document.getElementsByClassName("dropdown-check-list");
            yl = y.length;
            for (i = 0; i < yl; i++) {
                if (elmnt == y[i]) {
                    arrNo.push(i)
                } else {
                    y[i].classList.remove("visible");
                }
            }
        }

        document.addEventListener('click', (event) => {
            const isClickInsideDropdown = event.target.closest('.dropdown-check-list');

            if (!isMobile && !isClickInsideDropdown) {
                closeAllSelect();
            }
        });
    }
}
